import { useContext } from "react";

import { RouteCollectionContext } from "@/shared/contexts";
import { RouteItem } from "@/shared/domain";

export const useRouteCollection = (): {
    routeCollection: RouteItem[];
} => {
    const context = useContext(RouteCollectionContext);

    return context;
};
